export const SETTINGS_GROUP = [
  "appearance",
  "artboard",
  "behavior",
  "beta",
  "advanced"
];
export const VIEWPORT = ["mobile", "desktop"];
